import type { ChartColor } from '../../charts/chartColors';
import type { ChartValueFormatter } from '../../charts/chartTypes';
import { ReportFormatHelper } from '../../helpers/ReportFormatHelper';

export const SERIES_COLORS: ChartColor[] = [
  'blue',
  'emerald',
  'violet',
  'amber',
  'indigo',
  'orange',
  'rose',
  'gray',
];

export const CURRENCY_AXIS_WIDTH = 56;

export const moneyFormatter =
  (currency: string): ChartValueFormatter =>
  (value) =>
    ReportFormatHelper.currency(value, currency, { compact: true });

export const percentFormatter: ChartValueFormatter = (value) =>
  ReportFormatHelper.percent(value, 0);
